import { Login } from '@ipc/ipc-components';
import {
  Auth,
  initLoginAction,
  loginFailedAction,
  loginSucceededAction,
  OAuthAuthenticationService,
  Redirect,
} from '@ipc/ipc-core';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { LoginContainerStyle } from './Login.style';
import { getAssetType } from './asset-types/redux/selectors/AssetTypesSelectors';

const mapStateToProps = (state) => ({
  auth: new Auth(state.global.auth),
  appContext: getAssetType(state),
});

const mapDispatchToPro = {
  initLogin: initLoginAction,
  loginSucceeded: loginSucceededAction,
  loginFailed: loginFailedAction,
};

const INVALID_CREDENTIALS = 'invalid_grant';
const UNEXPECTED_ERROR = 'error.unexpected_error';

const createLoginResultHandler = (loginSucceeded, loginFailed) => ({ error, data }) => {
  if (error) {
    if (error.error === INVALID_CREDENTIALS) {
      loginFailed(error);
    } else {
      loginFailed(UNEXPECTED_ERROR);
    }
  } else {
    loginSucceeded(data);
  }
};

export class LoginComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToReferrer: false,
    };
  }

  login = (username, password) => {
    const {
      initLogin, loginSucceeded, loginFailed,
    } = this.props;

    const loginHandler = createLoginResultHandler(loginSucceeded, loginFailed);
    initLogin(username, password);
    OAuthAuthenticationService.login({ username, password, callback: loginHandler });
  };

  render() {
    const { location, auth, appContext } = this.props;
    const { from } = location.state || { from: { pathname: location.pathname } };
    const { redirectToReferrer } = this.state;

    if (auth.isAuthenticated()) {
      const to = redirectToReferrer === true && appContext.appContext !== null ? from : '/application-type';
      return <Redirect to={to} />;
    }

    const errorMessage = (auth.error) ? <FormattedMessage id={auth.error} /> : '';
    return (
      <LoginContainerStyle>
        <Login login={this.login} errorMessage={errorMessage} />
      </LoginContainerStyle>
    );
  }
}

LoginComponent.propTypes = {
  location: PropTypes.objectOf(PropTypes.shape),
  initLogin: PropTypes.func,
  loginSucceeded: PropTypes.func,
  loginFailed: PropTypes.func,
  auth: PropTypes.instanceOf(Auth),
  appContext: PropTypes.objectOf(PropTypes.string),
};

export default connect(mapStateToProps, mapDispatchToPro)(LoginComponent);
